import { Button, Collapse, Stack, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { type FC, type PropsWithChildren, useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { hasAnyDetailValue } from "web_myplann/Shared/Utils/hasAnyDetailValue";

const PageResources = Resources.PortfolioDetail.Property;

type Props = {
	noun: "realEstate" | "vehicle";
	values: (string | number | null | undefined)[];
};

export const PropertyExtendedParams: FC<PropsWithChildren<Props>> = ({
	noun,
	values,
	children,
}) => {
	const { t } = useResource();
	const theme = useTheme();
	const [expanded, setExpanded] = useState(false);

	if (!hasAnyDetailValue(...values)) {
		return null;
	}

	const nounLabel = t(
		noun === "vehicle"
			? PageResources.ParametersNounVehicle
			: PageResources.ParametersNounRealEstate,
	);

	return (
		<Stack>
			<Collapse in={expanded} timeout="auto" unmountOnExit>
				<Stack>{children}</Stack>
			</Collapse>
			<Button
				variant="disclosure"
				aria-expanded={expanded}
				onClick={() => setExpanded((prev) => !prev)}
				endIcon={
					expanded ? (
						<ChevronUp size={theme.iconSize.sm} />
					) : (
						<ChevronDown size={theme.iconSize.sm} />
					)
				}
			>
				{t(
					expanded
						? PageResources.HideParameters
						: PageResources.ShowParameters,
					{
						noun: nounLabel,
					},
				)}
			</Button>
		</Stack>
	);
};
